<template>

    <AppLayout :title="__('Company')">

        <UpdateTeamNameForm class="mb-10"
            :team="team"
            :permissions="permissions"
        />


        <AddTeamMember class="mb-10"
            :team="team"
            :available-roles="availableRoles"
        />


        <TeamMemberManager
            :team="team"
            :available-roles="availableRoles"
        />


        <NotificationsSettingsWidget class="mb-10"
            :is_company_defaults="true"
            :days="days"
        />


        <NotificationsVacationWidget class=""
            :is_company_defaults="true"
            :vacations="vacations"
        />

    </AppLayout>

</template>

<script>

import { defineComponent } from 'vue'
import AppLayout from "../../Layouts/AppLayout";
import UpdateTeamNameForm from "./Partials/UpdateTeamNameForm";
import AddTeamMember from "./Partials/AddTeamMember";
import TeamMemberManager from "./Partials/TeamMemberManager";
import NotificationsSettingsWidget from "../../Widgets/NotificationsSettingsWidget";
import NotificationsVacationWidget from "../../Widgets/NotificationsVacationWidget";

export default defineComponent({

    props: {
        team: Object,
        availableRoles: Array,
        permissions: Array,
        days: Array,
        vacations: Array
    },


    components: {
        NotificationsVacationWidget,
        NotificationsSettingsWidget,
        AppLayout,
        UpdateTeamNameForm,
        AddTeamMember,
        TeamMemberManager,
    },

});

</script>
